import React, { useState, useEffect } from 'react';
import { Form, Input, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { loginSelector } from '../../api/authSlice';
import { cartCouponSelector } from '../../api/cartSlice';

export default function Shipping({ actionMethod, info, voucher }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { curr_user } = useSelector(loginSelector);
  const { cartCoupons } = useSelector(cartCouponSelector);
  const [isproduct, setProduct] = useState(false);

  useEffect(() => {
    const found = cartCoupons.find((item) => item.type === 'product');
    if (found) {
      setProduct(true);
    }
  }, [cartCoupons]);

  const onFinish = (values) => {
    dispatch(actionMethod());
    dispatch(info(values));
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  useEffect(() => {
    if (curr_user) {
      form.setFieldsValue({
        email: curr_user.email,
        phone_number: curr_user.phone_number,
      });
    }
  }, [curr_user]);

  return (
    <div className="my-4 px-2 sm:px-4 lg:px-16 max-w-lg mx-auto">
      <Form
        form={form}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className="space-y-4"
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, message: 'Please input your email!' }]}
          className="w-full"
        >
          <Input className="w-full" />
        </Form.Item>

        <Form.Item
          label="Phone Number"
          name="phone_number"
          rules={[{ required: true, message: 'Please input your phone number!' }]}
          className="w-full "
        >
          <Input className="w-full" />
        </Form.Item>

        {isproduct && (
          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: 'Enter Valid Address' }]}
            className="w-full"
          >
            <Input.TextArea className="w-full" />
          </Form.Item>
        )}

        <Form.Item>
          <button
            className="w-full md:w-auto px-6 py-2 mt-4 text-white bg-purple-600 rounded-md shadow-md hover:bg-purple-700 transition-colors"
            type="primary"
            htmlType="submit"
          >
            Next
          </button>
        </Form.Item>
      </Form>
    </div>
  );
}
